module.exports = "<div class=\"drzzle-global-component\">\n  <span>\n    <notifications-container></notifications-container>\n  </span>\n  <fetch-origin></fetch-origin>\n  <transition name=\"drzPage\" mode=\"out-in\">\n    <router-view></router-view>\n  </transition>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/template.html
// module id = ZT49
// module chunks = 0